import React, { useContext, useEffect, useState } from 'react';
import './styles.less';
import { CreateSearchAlert } from 'shared-components/Components/SearchAlert/CreateSearchAlert/web';
import { ActiveFiltersTags } from '../ActiveFiltersTags/web';
import { useFilters } from 'shared-components/Components/Filters/Filters.hook';
import { normalizeTextToLowerCase } from '@Utils/Functions';
import ToggleInput from 'shared-components/Components/ToggleInput/web';
import { DownArrow } from 'shared-components/Components/CustomIcons/DownArrow/web';
import { Location as NewLocation } from 'shared-components/Components/Filters/Location/newLocation';
import { useSearchResultsFilters } from '../Filters/SearchResultsFilters.hook';
import { useActiveFiltersTags } from '../ActiveFiltersTags/ActiveFiltersTags.hook';
import { ConfigStateContext } from 'shared-components/Contexts/Configurations/context';
import InputFilterBox from './InputFilterBox/web';
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import {
	buildingFloor,
	dispositionFilter,
	seaDistance,
	seasonsFilters,
} from './options';
import { DataOptionsTypes } from './types';
import { Keywords } from './Keywords/web';
import { CheckIcon } from 'shared-components/Components/CustomIcons/CheckIcon/web';
import Show from 'src/Components/Show/web';
import { Amenities } from './Amenities/web';
import { BedroomsFilter } from './Beedrooms/web';
import { PropertyTypeFilter } from './PropertyType/web';
import { OperationTypeFilter } from './OperationType/web';
import { RangePriceFilter } from './RangePrice/web';
import { PropertyStatusFilter } from './PropertyStatus/web';
import { BathroomsFilter } from './Bathrooms/web';
import { StratumFilter } from './Stratum/web';
import { PublicationDateFilter } from './PublicationDate/web';
import { GaragesFilter } from './Garages/web';
import { AgeOfThePropertyFilter } from './AgeOfTheProperty/web';
import { RangeMetersFilters } from './RangeMeters/web';
import { LocationSearch } from 'src/Components/Filters/LocationSearch/web';

export const watchCheckedInFilter = (filterTypeObj, filterType, hasAll = false) => {
	const validHasAllChecked = (val) => {
		if (hasAll && val.value === 0 && !filterType) {
			return val.value === 0
		}
		return filterType?.includes(val.value)
	}
	return filterTypeObj ? filterTypeObj.map((val) => ({ ...val, value: val.value, text: val.text, checked: validHasAllChecked(val) })) : []
}

const TopBarFilters = () => {
	const { filters } = useFilters();
	const { changeFiltersAndUpdateURL: changeFilters } = useSearchResultsFilters();
	const { country_code, translations } = useContext(ConfigStateContext);
	const { filtersTagsToShow } = useActiveFiltersTags();
	const [showSeasons, setShowSeasons] = useState<boolean>(filters?.season ? true : false)
	const [guests, setGuests] = useState<number>(filters?.guests ? filters?.guests : 0)
	const [rangeDate, setRangeDate] = useState<any>([filters?.dateFrom && filters?.dateFrom, filters?.dateTo && filters?.dateTo]);
	const [calendarIsOpen, setCalendarIsOpen] = useState<boolean>()
	const buildingFloorList: DataOptionsTypes[] = watchCheckedInFilter(buildingFloor, filters?.floors)
	const dispositionFilterList: DataOptionsTypes[] = watchCheckedInFilter(dispositionFilter, filters?.dispositionID)

	const filtersOfTypeArray = [
		"property_type_id",
		"bedrooms",
		"bathrooms",
		"constStatesID",
		"neighborhood_id",
		"amenitiesGroup",
		"stratum",
		"antiquity"
	];

	useEffect(() => {
		if (country_code === "CO") {
			changeFilters({ currencyID: { text: undefined, value: 4 } })
			filtersOfTypeArray.push("garage")
		}
	}, [country_code])

	const handleFilterChange = (
		value: number,
		checked: boolean,
		list: DataOptionsTypes[],
		filterName: string
	) => {
		if (list.length) {
			let newOptions = list?.map((item) =>
				item.value == value ? { ...item, checked: checked } : item
			);
			let newFilters = newOptions
				.filter((v) => v.checked)
				.map((e) => {
					let newText = e.text;
					if (country_code === 'CO') {
						if (filterName === 'garage') {
							newText = `${e.text} parqueadero${e.value === 1 ? '' : 's'}`;
						} else if (filterName === 'stratum') {
							newText = `${e.value === 7 ? '' : 'Estrato'} ${e.text}`;
						}
					}
					return { value: e.value, text: newText }
				});
			changeFilters({ [filterName]: newFilters });
		}
	};

	const handleFloor = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { value, checked } = e?.target
		handleFilterChange(Number(value), checked, buildingFloorList, 'floors')
	}

	const handleDisposition = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { value, checked } = e?.target
		handleFilterChange(Number(value), checked, dispositionFilterList, 'dispositionID')
	}

	const handleCleanFilters = () => {
		filtersTagsToShow.map((filter) => {
			if (filter.deleteable) {
				if (filtersOfTypeArray.includes(filter.key)) {
					changeFilters({ [filter.key]: [] })
				}
				else {
					changeFilters(filter.onChangeObject)
				}
			}
		})

		setRangeDate(null)
	}
	
	useEffect(() => {
		if (rangeDate && rangeDate[0]) {
			const startRange = rangeDate[0]
			const endRange = rangeDate[1]

			if (startRange || endRange) {
				changeFilters({ dateFrom: startRange && startRange !== '' ? { text: startRange, value: startRange } : null, dateTo: endRange && endRange !== '' ? { text: endRange, value: endRange } : null, season: null })
			}
			else if (!startRange && !endRange) {
				changeFilters({ dateFrom: null, dateTo: null, season: null })
			}
		}
	}, [rangeDate])

	useEffect(() => {
		if (!filters?.dateFrom && filters?.dateTo) {
			setRangeDate(['', filters?.dateTo])
		}
		if (!filters?.dateTo && filters?.dateFrom) {
			setRangeDate([filters?.dateFrom, ''])
		}
		if (!filters?.dateTo && !filters?.dateFrom) setRangeDate(null)
	}, [filters?.dateFrom, filters?.dateTo])

	const handleGuests = () => {
		if (guests !== 0) {
			changeFilters({ guests: { value: guests, text: `${guests} o más Huéspedes` } })
		}
		else {
			changeFilters({ guests: undefined })
		}
	}

	if (!country_code) return null;

	return (
		<div className="topBarFilters">
			<div className="topBarFilters__activeFilters">
				<ActiveFiltersTags />

				{filtersTagsToShow.length !== 1 && (
					<button onClick={handleCleanFilters} className="btn-third">
						Limpiar filtros
					</button>
				)}
			</div>

			<div className="topBarFilters__container">
				{/* Filtro ubicación */}
				<div className="topBarFilters__searchKeyword">
					<LocationSearch showSearchBtn={false} />
				</div>

				{/* Filtro de Tipo de Operación */}
				<OperationTypeFilter />

				{/* Filtro de Búsqueda por temporadas o fechas en Casas en el Este */}
				{country_code == "ce3" ||
					(filters?.operation_type_id && filters?.operation_type_id === 4 && country_code && country_code !== "CO") ? (
					<InputFilterBox
						label="Fechas"
						customWidth={360}
						customHeight={calendarIsOpen ? 515 : "unset"}>
						<div className="dateFilter">
							<div className="dateFilter__selectors">
								<button
									className="dateFilter__selector"
									disabled={!showSeasons}
									onClick={() => {
										setShowSeasons(false);
									}}>
									Buscar por Calendario
								</button>
								<Show when={country_code !== "CO"}>
									<button
										className="dateFilter__selector"
										disabled={showSeasons}
										onClick={() => {
											setShowSeasons(true);
										}}>
										Buscar por Temporada
									</button>
								</Show>
							</div>
							{showSeasons ? (
								<div className="otherFilters__container" id="publicationDate">
									<input
										className="otherFilters__dropDownIsActive"
										type="checkbox"
										id="selectSeason"
									/>
									<label
										className="otherFilters__dropDownSelector"
										htmlFor="selectSeason">
										Temporada
										<DownArrow />
									</label>
									<div className="otherFilters__dropdown">
										<div className="otherFilters__container__option more-filters">
											<input
												type="radio"
												className="radioCustomInput"
												name="season"
												id="indiferente"
												onChange={() =>
													changeFilters({
														season: null,
														dateFrom: null,
														dateTo: null,
													})
												}
												value="-1"
												defaultChecked
											/>
											<label htmlFor="indiferente">Indiferente</label>
										</div>
										{seasonsFilters.map((val, i) => {
											const idValue = normalizeTextToLowerCase(val.text);
											return (
												<div
													key={"season-filter - " + i}
													className="otherFilters__container__option more-filters">
													<input
														type="radio"
														className="radioCustomInput"
														name="season"
														id={idValue}
														onChange={() =>
															changeFilters({
																season: {
																	text: val.text,
																	value: val.value,
																},
																dateFrom: null,
																dateTo: null,
															})
														}
														value={val.value}
														defaultChecked={
															filters?.season &&
															filters?.season == val.value
														}
													/>
													<label htmlFor={idValue}>{val.text}</label>
												</div>
											);
										})}
									</div>
								</div>
							) : (
								<>
									<div className="dateFilter__labels">
										<span>Llegada</span>
										<div></div>
										<span>Salida</span>
									</div>
									<div className="dateFilter__calendar">
										<DateRangePicker
											format="dd/MM/yyyy"
											onChange={e => {
												if (e) {
													const values = e
														.toLocaleString("en", {
															year: "numeric",
															month: "2-digit",
															day: "2-digit",
														})
														.split(",");

													const dates = values.map(v => {
														if (v.split("/").length > 1) {
															const [month, day, year] = v.split("/");
															return `${year}/${month}/${day}`;
														} else "";
													});
													setRangeDate(dates);
												} else {
													setRangeDate(null);
												}
											}}
											value={rangeDate}
											calendarClassName=".filterCalendar"
											className=".filterCalendarPicker"
											minDate={new Date()}
											calendarIcon={null}
											clearIcon={null}
											onCalendarOpen={() => setCalendarIsOpen(true)}
											onCalendarClose={() => setCalendarIsOpen(false)}
										/>
									</div>
								</>
							)}
						</div>
					</InputFilterBox>
				) : (
					<></>
				)}

				{/* Filtro de Tipo de Propiedad */}
				<PropertyTypeFilter />

				{/* Filtro de Cantidad de Dormitorios */}
				<BedroomsFilter />

				{/* Filtro de Rango de Precios */}
				<RangePriceFilter />

				{/* Otros filtros */}
				<InputFilterBox label="Más filtros" customWidth={400} positionRight>
					<div className="otherFilters">
						{/* Filtro palabra clave */}
						<Keywords collapsable filterChanged={changeFilters} />

						{/* Estado de la Propiedad*/}
						{(filters.operation_type_id && filters.operation_type_id === 1) && !filters.projects ?
							country_code === "CO" ? <PropertyStatusFilter type='radio' /> : <PropertyStatusFilter type='checkbox' /> :
							null
						}

						{/* Filtro de Huéspedes*/}
						{country_code === "ce3" || (filters && filters?.operation_type_id == 4) && country_code !== 'CO' && (
							<div className="otherFilters__guests">
								<p>Huéspedes</p>
								<div className="otherFilters__count">
									<div>
										<button
											className="otherFilters__count__operation"
											disabled={guests === 0 ? true : false}
											onClick={() => setGuests(guests - 1)}>
											-
										</button>
										<input
											type="number"
											name="guests"
											id="guests"
											value={guests}
											onChange={e => setGuests(Number(e.target.value))}
										/>
										<button
											className="otherFilters__count__operation"
											onClick={() => setGuests(guests + 1)}>
											+
										</button>
									</div>
									<button
										className="otherFilters__count__submit"
										onClick={handleGuests}>
										<CheckIcon type="default" />
									</button>
								</div>
							</div>
						)}

						{/* Filtros de Baños */}
						<BathroomsFilter />

						{/* Filtros para Parqueaderos */}
						{country_code === "CO" && <GaragesFilter />}

						{/* Filtros de Estratos */}
						{country_code === 'CO' && <StratumFilter />}

						{/* Filtros de Antiguedad del inmueble */}
						{country_code === 'CO' && <AgeOfThePropertyFilter />}

						{/* Rango de Metraje */}
						<RangeMetersFilters />

						{/* Grupo de Opciones Toggle */}
						<div className="otherFilters__container" id="toggleFilters">
							{country_code !== 'ce3' && country_code !== 'CO' && <ToggleInput id='tour-virtual' label='Tour Virtual' name='virtualTour' onChange={(e) => changeFilters({ tour3d: e.target.checked ? { text: 'Tour Virtual 3D', value: true } : null })} defaultChecked={filters?.tour3d === true} />}
							{country_code !== 'CO' && <ToggleInput id='garage-filter' label='Garage' name='garage' onChange={(e) => changeFilters({ garage: e.target.checked ? { text: 'con Garage', value: 1 } : null })} defaultChecked={filters?.garage == 1} />}
							{(country_code !== 'ce3' && country_code !== 'CO') && <ToggleInput id="socialhousing" label='Vivienda social' name='viviendaSocial' onChange={(e) => changeFilters({ socialHousing: e.target.checked ? { text: 'Vivienda Social', value: true } : null })} defaultChecked={filters?.socialHousing} />}
							{country_code !== 'CO' && <ToggleInput id="privateowner-filter" label="Publicado por el dueño" name='publicateowner-filter' onChange={(e) => changeFilters({ privateOwner: e.target.checked ? { text: 'Dueño', value: true } : null })} defaultChecked={filters?.privateOwner} />}
							{country_code !== 'ce3' && country_code !== 'CO' && <ToggleInput id="condominium-filter" label={country_code === "UY" ? "Barrio Privado" : "Condominio"} name="condominium-filter" onChange={(e) => changeFilters({ condominium: e.target.checked ? { text: 'Condominios', value: true } : null })} defaultChecked={filters?.condominium} />}
						</div>

						{<Amenities />}

						{/* Fecha de Publicación */}
						<PublicationDateFilter />

						{/* Distancia al Mar */}
						{country_code !== "PY" && country_code !== "BO" && country_code !== 'CO' && (
							<div className="otherFilters__container" id="seaDistance">
								<input
									className="otherFilters__dropDownIsActive"
									type="checkbox"
									id="seaDistanceFilterDropdown"
								/>
								<label
									className="otherFilters__dropDownSelector"
									htmlFor="seaDistanceFilterDropdown">
									Distancia al Mar
									<DownArrow />
								</label>
								<div className="otherFilters__dropdown">
									<div className="otherFilters__container__option more-filters">
										<input
											type="radio"
											className="radioCustomInput"
											name="sea-distance-filter"
											id="cualquiera"
											onChange={() => changeFilters({ seaDistanceID: null })}
											value="-1"
											defaultChecked
										/>
										<label>Cualquier Distancia</label>
									</div>
									{seaDistance.map((val, i) => {
										return (
											<div
												key={"sea-distance-filter - " + i}
												className="otherFilters__container__option more-filters">
												<input
													type="radio"
													className="radioCustomInput"
													name="sea-distance-filter"
													id={val.text}
													onChange={() =>
														changeFilters({
															seaDistanceID: {
																value: val.value,
																text:
																	val.value === 1
																		? val.text
																		: `${val.text} del mar`,
															},
														})
													}
													value={val.value}
													defaultChecked={
														filters?.seaDistanceID &&
														filters?.seaDistanceID === val.value
													}
												/>
												<label htmlFor={val.text}>{val.text}</label>
											</div>
										);
									})}
								</div>
							</div>
						)}
						
						{//validación para que aparezca el filtro de pisos en el caso de que el tipo de propiedad sea departamento o apartamento
							country_code !== "ce3" && country_code !== 'CO' &&
							filters?.property_type_id &&
							filters?.property_type_id.includes(2) && (
								<>
									{/* Cantidad de Pisos */}
									<div className="otherFilters__container" id="buildingFloor">
										<input
											className="otherFilters__dropDownIsActive"
											type="checkbox"
											id="floorsFiltersDropdown"
										/>
										<label
											className="otherFilters__dropDownSelector"
											htmlFor="floorsFiltersDropdown">
											Pisos
											<DownArrow />
										</label>
										<div className="otherFilters__dropdown">
											{buildingFloorList.map((val, i) => {
												const idValue = normalizeTextToLowerCase(val.text);
												return (
													<div
														key={"building-floor - " + i}
														className="otherFilters__container__option more-filters">
														<input
															type="checkbox"
															className="checkBoxCustomInput"
															name="building-floor"
															onChange={handleFloor}
															checked={val.checked ? true : false}
															id={idValue}
															value={val.value}
														/>
														<label htmlFor={idValue}>{val.text}</label>
													</div>
												);
											})}
										</div>
									</div>

									{country_code !== 'CO' ? <div className="otherFilters__container" id="disposition">
										<input
											className="otherFilters__dropDownIsActive"
											type="checkbox"
											id="dispositionFiltersDropdown"
										/>
										<label
											className="otherFilters__dropDownSelector"
											htmlFor="dispositionFiltersDropdown">
											Disposición
											<DownArrow />
										</label>
										<div className="otherFilters__dropdown">
											{dispositionFilterList.map((val, i) => {
												const idValue = normalizeTextToLowerCase(val.text);
												return (
													<div
														key={"disposition-filter - " + i}
														className="otherFilters__container__option more-filters">
														<input
															type="checkbox"
															className="checkBoxCustomInput"
															name="dispositionFilter"
															onChange={handleDisposition}
															checked={val.checked ? true : false}
															id={idValue}
															value={val.value}
														/>
														<label htmlFor={idValue}>{val.text}</label>
													</div>
												);
											})}
										</div>
									</div> : <></>}
								</>
							)}
					</div>
				</InputFilterBox>

				<div className="topBarFilters__createAlert">
					<CreateSearchAlert />
				</div>
			</div>
		</div>
	);
}




export default TopBarFilters